import PurchaseRegistration from 'modules/purchase/PurchaseRegistration';
import Header from 'modules/header/farm/main';
import React from 'react';

const PurchaseRegistrationContainer = () => {
  return (
    <div className="flex w-full h-full flex-col">
      <Header title="ثبت آگهی خرید" />
      <PurchaseRegistration type="farmer" />
    </div>
  );
};

export default PurchaseRegistrationContainer;
